export const ADD_INSPECTION = "ADD_INSPECTION";
export const INSPECTION_UNITS = "INSPECTION_UNITS";
export const TOGGLE_DRAW_MODE = "TOGGLE_DRAW_MODE";
export const TOGGLE_DISAGREE_MODE = "TOGGLE_DISAGREE_MODE";
export const TOGGLE_PASSRESUME_MODE = "TOGGLE_PASSRESUME_MODE";
export const TOGGLE_PASSRESUME_CLICK_MODE = "TOGGLE_PASSRESUME_CLICK_MODE";
export const SET_SAMPLE_IMAGES = "SET_SAMPLE_IMAGES";
export const SET_BBOX = "SET_BBOX";
export const SET_SELECTED_DEFECT = "SET_SELECTED_DEFECT";
export const INSPECTION_PLANT_DATA = 'SET_SHARED_DATA';
export const SET_SELECTED_REASON = 'SET_SELECTED_REASON';
export const SET_PREDICTION_LABELS = 'SET_PREDICTION_LABELS';
export const SET_UNIT_COUNT = 'SET_UNIT_COUNT';
export const CANVAS_HEIGHT = 'CANVAS_HEIGHT';
export const SET_CRITERIA_SUMMARY = "SET_CRITERIA_SUMMARY";
export const SET_CRITERIA_LOGS = "SET_CRITERIA_LOGS";
export const LOG_CATEGORY_EVENT = "LOG_CATEGORY_EVENT";
export const CLEAR_CATEGORY_EVENTS = "CLEAR_CATEGORY_EVENTS";
export const SET_STATUS_TEXT = "SET_STATUS_TEXT";

